export { AGENT_TONE_VALUES, STAFF_CONNECTION_METHOD_VALUES, VOICE_SETTINGS_DEFAULTS, VOICE_OPTIONS, } from './agent-voice-settings-constants.js';
export const AGENT_CHANNELS = {
    CALL: 'CALL',
    EMAIL: 'EMAIL',
    SMS: 'SMS',
};
export const AGENT_CHANNEL_VALUES = ['CALL', 'EMAIL', 'SMS'];
// Outbound trigger types
export const OUTBOUND_TRIGGER_TYPE_VALUES = [
    'LEAD_WEBHOOK',
    'PAYMENT_OVERDUE_WEBHOOK',
    'SCENARIO',
];
// Inbound trigger types
export const INBOUND_TRIGGER_TYPE_VALUES = ['INBOUND_CALL', 'SCENARIO'];
//# sourceMappingURL=agent-voice-settings.js.map